export default __webpack_public_path__ + "static/media/routinely3.f2854f7d.png";